"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const InfoMessage = _ref => {
  let {
    header,
    text,
    onClose
  } = _ref;
  const {
    OK
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      px: 3,
      py: 2,
      maxWidth: 550,
      margin: '0 auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontSize: '18px !important',
      // important will be removed when theme is added
      fontWeight: 700,
      color: _constants.colors['main-color-cl-01'],
      mb: 3,
      textAlign: 'center'
    },
    variant: "subtitle1",
    color: "text.primary"
  }, header || /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    sx: {
      bgcolor: 'currentColor'
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontSize: 14,
      fontWeight: 700,
      color: _constants.colors['main-color-cl-01'],
      textAlign: 'center'
    },
    variant: "body2",
    color: "text.primary"
  }, text || /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    sx: {
      bgcolor: 'currentColor'
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.CardActions, {
    sx: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, onClose && /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    size: "large",
    disableElevation: true,
    onClick: onClose
  }, OK || /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    variant: "text",
    sx: {
      bgcolor: 'currentColor'
    }
  }))));
};
exports.InfoMessage = InfoMessage;
InfoMessage.propTypes = {
  header: _propTypes.default.string,
  text: _propTypes.default.string,
  onClose: _propTypes.default.func
};